import React from 'react'

interface HeaderProps {
  children?: React.ReactNode
  className?: string
}

export const WideHeader: React.FC<HeaderProps> = ({ children, className }) => {
  return (
    <header
      className={`z-[100] flex h-[89px] min-h-[89px] w-full flex-row items-center gap-2 bg-white px-7 shadow-[0_0_2px_1px_rgba(0,0,0,0.08)] sm:px-20 ${className}`}
    >
      {children}
    </header>
  )
}

export const Header: React.FC<HeaderProps> = ({ children, className }) => {
  return (
    <header
      className={`z-[100] flex h-[50px] min-h-[50px] w-full flex-row items-center gap-2 bg-white px-2 py-1 shadow-header ${className}`}
    >
      {children}
    </header>
  )
}
